export default {
  navigationBarTitleText: intl.get('leafFile.title')
};
